import React from "react";
const GestionMacros = ({setGestionarMacros}) => {
    
    const ingresarAMacros = () => {
        setGestionarMacros(true); // Cambiar el estado en el componente padre
    };

    return (
        // Contenido para usuarios autenticados
        <div className="card shadow-lg p-3 mb-5 bg-white rounded w-100 ">
            <h3 className="text-center mb-4">Gestión de Makros</h3>
            <div className="card-body ">
                <div class="row">
                    <div class="col-12">
                        <p className="text-center">
                            puede gestionar las makros actuales aquí.
                        </p>

                    </div>
                    <div class="col-12 d-flex justify-content-center">
                        <button className="btn btn-danger mt-3" onClick={ingresarAMacros}>
                            Ingresar
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
}
export default GestionMacros;